import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheckIcon, DownloadIcon, PrinterIcon } from 'lucide-react';
export function PricingSection() {
  return <Section alternate id="pricing" className="relative" data-id="element-147">
      <div className="absolute inset-0 bg-amber-500/5 pointer-events-none" data-id="element-148" />

      <div className="relative bg-warm-900 rounded-2xl border border-amber-500/30 shadow-[0_0_40px_rgba(245,158,11,0.1)] overflow-hidden" data-id="element-149">
        <div className="h-2 bg-amber-500 w-full" data-id="element-150" />

        <div className="p-8 md:p-12 text-center" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-serif text-cream-50 mb-2" data-id="element-152">
            "3AM otra vez"
          </h2>
          <p className="text-cream-100 opacity-70 mb-8" data-id="element-153">Kit Digital Completo</p>

          <div className="flex items-center justify-center mb-8" data-id="element-154">
            <div className="text-center" data-id="element-155">
              <span className="text-2xl text-cream-100/50 line-through font-serif" data-id="element-156">
                $19
              </span>
              <div className="flex items-center justify-center mt-1" data-id="element-157">
                <span className="text-5xl md:text-6xl font-bold text-amber-500 font-serif" data-id="element-158">
                  $6.39
                </span>
                <span className="ml-3 text-left text-sm text-cream-100 opacity-60 leading-tight" data-id="element-159">
                  USD
                  <br data-id="element-160" />
                  Pago único
                </span>
              </div>
              <span className="inline-block mt-2 px-3 py-1 bg-amber-500/20 text-amber-500 text-sm font-bold rounded-full tracking-wide" data-id="element-161">
                66% OFF — Oferta limitada
              </span>
            </div>
          </div>

          <p className="text-lg text-cream-100 mb-8 max-w-md mx-auto" data-id="element-162">
            Una vez. Descarga inmediata. Lo puedes imprimir.
            <br data-id="element-163" />
            <br data-id="element-164" />
            <span className="italic text-cream-50" data-id="element-165">
              Porque la próxima vez que te pase, no necesitas buscar en
              internet. Necesitas una tarjeta.
            </span>
          </p>

          <Button fullWidth href="https://vitalrutinas.com/cart/53259314495856:1" className="text-xl py-5 mb-6 animate-pulse-slow" data-id="element-166">
            Quiero el Kit "3AM otra vez"
          </Button>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-4 text-sm text-cream-100/60 max-w-sm mx-auto text-left sm:text-center" data-id="element-167">
            <div className="flex items-center sm:justify-center" data-id="element-168">
              <DownloadIcon className="w-4 h-4 mr-2" data-id="element-169" />
              Descarga inmediata (PDF)
            </div>
            <div className="flex items-center sm:justify-center" data-id="element-170">
              <PrinterIcon className="w-4 h-4 mr-2" data-id="element-171" />
              Hojas imprimibles incluidas
            </div>
            <div className="flex items-center sm:justify-center" data-id="element-172">
              <ShieldCheckIcon className="w-4 h-4 mr-2" data-id="element-173" />
              Español claro (USA)
            </div>
            <div className="flex items-center sm:justify-center" data-id="element-174">
              <span className="w-4 h-4 mr-2 flex items-center justify-center font-bold text-xs border border-current rounded-full" data-id="element-175">
                !
              </span>
              Sin jerga. Sin drama.
            </div>
          </div>
        </div>
      </div>
    </Section>;
}